import {getItemsStatic} from "./inventory";

const DATA_MODE_REST = "REST";
const DATA_MODE_STATIC = "STATIC";
const DATA_MODE_DEMO = "DEMO";
const DATA_MODE = DATA_MODE_STATIC;


export async function getData() {
    if (DATA_MODE === DATA_MODE_REST) {
        const resultData = await fetch("http://localhost:9000/testAPI")
            .then(res => res.text())
            .then(res => JSON.parse(res));

        return resultData;
    } else if (DATA_MODE === DATA_MODE_DEMO) {
        return getDemoItems();
    } else {
        return getItemsStatic();
    }
}

export async function findData(useDemoData, itemName) {
    return await find(useDemoData, itemName, 0);
}

export async function findNext(useDemoData, itemName) {
    return await find(useDemoData, itemName, 1);
}

export async function findPrevious(useDemoData, itemName) {
    return await find(useDemoData, itemName, -1);
}

export async function find(useDemoData, itemName, offset) {

    let allItems;

    if (DATA_MODE === DATA_MODE_REST) {
        allItems = await fetch("http://localhost:9000/testAPI")
            .then(res => res.text())
            .then(res => JSON.parse(res));

    } else {
        allItems = getItemsStatic();
    }
    let foundIndex = -1;
    for (let i = 0; i < allItems.length; i++) {
        let found = allItems[i]["Name"] === itemName;
        if (found) {
            foundIndex = i;
        }
    }


    if (foundIndex === -1) {
        return null;
    } else {
        let nextIndex = foundIndex + offset;
        if (nextIndex < 0 || nextIndex >= allItems.length) {
            return null;
        } else {
            return allItems[nextIndex];
        }
    }

}

function getDemoItems() {
    let demoItems =
        [
            {
                "Company": "Acorn",
                "Name": "Acorn Electron",
                "Value": 130,
                "Amount": 1,
                "Category": "Personal Computers"
            },
            {
                "Company": "Apple",
                "Name": "Apple II",
                "Value": 100,
                "Amount": 1,
                "Category": "Personal Computers"
            },
            {
                "Company": "Apple",
                "Name": "Apple IIc",
                "Value": 150,
                "Amount": 2,
                "Category": "Personal Computers"
            },
            {
                "Company": "Commodore",
                "Name": "KIM-1",
                "Value": 500,
                "Amount": 1,
                "Category": "Single Board Computers"
            }
        ];
    return demoItems;
}

export default getData();